module.exports = __webpack_public_path__ + "static/media/logo-small.cbc9256c.svg";